import { QueryResult } from '@apollo/client';
import { LocationQuery, LocationQueryVariables, useLocationQuery } from 'generated/graphql';
import { useForm, UseFormReturn } from 'react-hook-form';
import { useParams } from 'react-router-dom';

type FormData = {
  address: string;
  maxSuites: number;
  name: string;
};

const getFormData = ({ location }: LocationQuery): FormData => ({
  address: location.address,
  maxSuites: location.maxSuites,
  name: location.name,
});

export const useEditLocationForm = (): [
  QueryResult<LocationQuery, LocationQueryVariables>,
  UseFormReturn<FormData, any>
] => {
  const { locationId: id } = useParams() as { locationId: string };
  const form = useForm<FormData>();

  const location = useLocationQuery({
    variables: { id },
    onCompleted: data => form.reset(getFormData(data)),
  });

  return [location, form];
};
